import {
    count_AT_ALL,
    FEED_DISPLAY_MORE,
} from 'mk/autogenerated/translations/StrollersList.b556c9f3c39c70bb2579cfc5cbd99c5d'
import { StrollerCard, StrollerCardPlaceholder } from 'mk2/apps/strollers/components/StrollerCard';
import { dummyPhoto } from 'mk2/apps/strollers/constants';
import { StrollerEntity, StrollerPhoto, StrollerVariantEntity } from 'mk2/apps/strollers/schemas';
import { Btn, BtnType } from 'mk2/components/Btn';
import { NoResults } from 'mk2/components/NoResults';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { isLoading, LoadingState } from 'mk2/reducers/loadingState';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './StrollersList.mscss';

interface OwnProps {
    items: StrollerEntity[];
    strollerIdToVariantsMap: Record<number, StrollerVariantEntity[]>;
    hasMore: boolean;
    count: number;
    loadingState: LoadingState;
    comparison: number[];
    noResultMessage: string;
    strollersPreviewPhotoMap: Record<number, number>;
    variantsPreviewPhotoMap: Record<number, number>;
    photoObjectsMap: Record<number, StrollerPhoto>;
    searchData?: any;

    load();
    loadNext();
    onComparisonToggle(strollerId);
}

interface State {
    client: boolean;
}

export class StrollersList extends React.Component<OwnProps, State> {
    public static defaultProps: Partial<OwnProps> = {};

    public state: State = {
        client: false,
    };

    public componentDidMount() {
        this.setState({
            client: true,
        });
    }

    public render() {
        const { items, load, loadingState } = this.props;
        const strollers = typeof items !== 'undefined' ? items : [];

        return (
            <div className={styles.StrollersList}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={load}
                    onRenderInit={this.renderInit}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={strollers && strollers.length > 0}
                />
            </div>
        );
    }

    private renderInit = () => {
        return (
            <div className={styles.StrollersList__items}>
                {Array.from(Array(8).keys()).map((index) => (
                    <div key={index} className={styles.StrollersList__items__container}>
                        <StrollerCardPlaceholder className={styles.StrollersList__items__container__item} />
                    </div>
                ))}
            </div>
        );
    };

    private renderLoadSuccess = () => {
        const { count,
                hasMore,
                items,
                strollerIdToVariantsMap,
                loadingState,
                noResultMessage,
                comparison,
                searchData,
                strollersPreviewPhotoMap,
                variantsPreviewPhotoMap,
                photoObjectsMap,
                loadNext,
              } = this.props;
        return items.length > 0 ? (
            <div className={styles.StrollersList__items}>
                {items.map((item, index) => (
                    <StrollerCard
                        key={index}
                        className={styles.StrollersList__items__container__item}
                        stroller={item}
                        strollerPhoto={item.id in strollersPreviewPhotoMap && strollersPreviewPhotoMap[item.id]
                                        in photoObjectsMap ? photoObjectsMap[strollersPreviewPhotoMap[item.id]] : null}
                        variant={!!strollerIdToVariantsMap && item.id in strollerIdToVariantsMap && strollerIdToVariantsMap[item.id].length > 0 ? strollerIdToVariantsMap[item.id][0] : null}
                        variantsPreviewPhotoMap={variantsPreviewPhotoMap}
                        photoObjectsMap={photoObjectsMap}
                        isInComparison={comparison.includes(item.id)}
                        onComparisonToggle={this.onComparisonToggle}
                        searchData={searchData}
                    />
                ))}
                {isLoading(loadingState) && (
                    <>
                        {Array.from(Array(3).keys()).map((index) => (
                            <div key={index} className={styles.StrollersList__items__container}>
                                <StrollerCardPlaceholder className={styles.StrollersList__items__container__item} />
                            </div>
                        ))}
                    </>
                )}
                {Boolean(hasMore || count) && (
                    <div className={styles.StrollersList__footer}>
                        {hasMore && (
                            <Btn
                                label={`${FEED_DISPLAY_MORE} (${count - items.length})`}
                                onClick={loadNext}
                                type={BtnType.BlueOutline}
                            />
                        )}
                        {Boolean(count) && (
                            <div className={styles.StrollersList__footer__count}>
                                { interpolate(count_AT_ALL, { count }) }
                            </div>
                        )}
                    </div>
                )}
            </div>
        ) : (
            <NoResults message={noResultMessage} noIcon />
        );
    };

    private onComparisonToggle = (strollerId: number) => {
        this.props.onComparisonToggle(strollerId);
    };
}
